import { Container } from "./styles";
import loginBackgroung from "../../Assets/loginBackgroung.svg";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <Container>
      <h1>
        OPS ! <span> A página que você está procurando não foi encontrada</span>
      </h1>

      <img alt="error" src={loginBackgroung}></img>
      <div>
        <p>
          <Link to="/">
            <h2>
              Entre agora no <span className="HCloud">HCloud</span>
            </h2>
          </Link>
        </p>
      </div>
    </Container>
  );
};

export default PageNotFound;
